
import React, { useState } from 'react';
function NavBar({ onClickDiv, hidesolda }) {
    const months = ['February', 'March', 'April', 'May'];
    const [active, setActive] = useState('All Time');
    const solder = '€238,500.75';
    const [hidesold, sethidesold] = useState(false);
    const handleClick = (messages) => {
        console.log(messages);
        alert(messages);
    };

    const handleClickTime = (monthh) => {
        setActive(monthh);
        onClickDiv(monthh);
    };
    const handleClickHide = () => {
        sethidesold(prev => !prev);
        hidesolda();
    };

    return (
        <nav className="fixed ltr-direction top-0 left-0 right-0 z-10 w-full bg-gray-800">
            <div className='flex justify-between items-center'>
                <button onClick={() => handleClick('menus')} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                    <img
                        src="./paysera/nav_1.png"
                        alt="Icon Button"
                        style={{ width: '30px', height: '30px' }}
                    />
                </button>
                <div onClick={() => handleClickHide()} className="semi-bold text-center text-3xl p-4 cursor-pointer text-white">
                    {hidesold ? '**********' : solder}
                </div>
                <button onClick={() => handleClick('search')} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                    <img
                        src="./paysera/nav_2.png"
                        alt="Icon Button"
                        style={{ width: '30px', height: '30px' }}
                    />
                </button>
            </div>
            <ul className="text-sm grid grid-cols-5 justify-between font-bold text-center p-4">
                {months.map((month) => (
                    <li
                        key={month}
                        onClick={() => handleClickTime(month)}
                        className={`cursor-pointer ${active === month ? 'text-white' : 'text-gray-500'
                            }`}
                    >
                        {month}
                    </li>
                ))}
                <li
                    onClick={() => handleClickTime('All Time')}
                    className={`cursor-pointer ${active === 'All Time' ? 'text-white' : 'text-gray-500'
                        }`}
                >
                    All Time
                </li>
            </ul>
        </nav>
    );
}
export default NavBar;